import getMetaEnv from "./meta";

// eslint-disable-next-line import/prefer-default-export
export const STORE_BASE_PATH = getMetaEnv("store::base_path");
